// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selection {
    background-color: #97bf0d;
}
.entry {
    padding: 5px;
    cursor: pointer;
}
.entry:hover {
    background-color: #97bf0d;
}
.list {
    height: 200px;
    border: 1px solid black;
    overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/components/reportobjectmenus/planning/sheets.menu.tab.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,cAAc;AAClB","sourcesContent":[".selection {\n    background-color: #97bf0d;\n}\n.entry {\n    padding: 5px;\n    cursor: pointer;\n}\n.entry:hover {\n    background-color: #97bf0d;\n}\n.list {\n    height: 200px;\n    border: 1px solid black;\n    overflow: auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
